import React from "react";
import { ColumnsType } from "antd/es/table";
import type { SortOrder } from "antd/es/table/interface";
import { TFunction } from "i18next";

import { positionsDirectorySortableColumns } from "~/pages/Editor/EditorDirectories/options";

export const positionDirectorySortFieldForApi = (option: string) => {
  switch (option) {
    case "positionCode":
      return "code";
    case "titlePosition":
    case "titlePositionEn":
      return "name";
    case "belongingDirectionID":
      return "directionId";
    case "RequiredEmail":
      return "requiredEmail";
    default:
      return option;
  }
};

export const getPositionDirectorySortableApiKeys = () =>
  Array.from(
    new Set(positionsDirectorySortableColumns.map(positionDirectorySortFieldForApi)),
  );

export const getPositionDirectoryColumns = (
  t: TFunction,
  options: string[],
  sortField?: string,
  sortType?: string,
): ColumnsType<any> =>
  options.map((option) => {
    const columnSortable = positionsDirectorySortableColumns.includes(option);
    const apiKey = positionDirectorySortFieldForApi(option);
    const sortOrder: SortOrder | undefined =
      columnSortable && sortField === apiKey
        ? sortType === "ASC"
          ? "ascend"
          : sortType === "DESC"
          ? "descend"
          : undefined
        : undefined;

    return {
      title: t(`positionDirectory.${option}`),
      dataIndex: option,
      key: columnSortable ? apiKey : option,
      sorter: columnSortable,
      sortOrder,
      render: (value: any) => {
        if (option === "showInZd" || option === "jobDescriptionIsRequired") {
          const flag = value === true || value === "true";
          return (
            <span>{flag ? t("ui.filterPositive") : t("ui.filterNegative")}</span>
          );
        }
        return <span>{value}</span>;
      },
    };
  });
